import React, { useState } from "react";
import { Modal, Stack, Text, TextInput, Button, Alert } from "@mantine/core";
import zIndex from "../../designTokens/zIndex";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export const DeleteAccountModal = ({ opened, onClose, onConfirm, userProfile }) => {
	const { t } = useTranslation();
	const [inputValue, setInputValue] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const handleConfirm = async () => {
		if (inputValue === userProfile?.username) {
			setIsLoading(true);
			try {
				await onConfirm();
			} finally {
				setIsLoading(false);
			}
		}
	};

	const handleClose = () => {
		setInputValue("");
		onClose();
	};

	const isValid = inputValue === userProfile?.username;

	return (
		<Modal
			opened={opened}
			onClose={handleClose}
			title={t("account.deleteAccount.modalTitle")}
			size="md"
			centered
			zIndex={zIndex.modal}
		>
			<Stack gap="md">
				<Alert icon={<IconAlertTriangle size={16} />} color="red" variant="light">
					<Text size="sm" fw={500}>
						{t("account.deleteAccount.warningTitle")}
					</Text>
					<Text size="sm" mt={4}>
						{t("account.deleteAccount.warningMessage")}
					</Text>
				</Alert>

				<Stack gap="xs">
					<Text size="sm">
						{t("account.deleteAccount.confirmationText", { 
							username: userProfile?.username 
						})}
					</Text>
					<Text size="sm" c="dimmed">
						{t("account.deleteAccount.typeUsername")}
					</Text>
				</Stack>

				<TextInput
					placeholder={userProfile?.username}
					value={inputValue}
					onChange={(event) => setInputValue(event.currentTarget.value)}
					data-autofocus
				/>

				<Stack gap="xs" mt="md">
					<Button
						color="red"
						variant="filled"
						onClick={handleConfirm}
						disabled={!isValid}
						loading={isLoading}
						fullWidth
					>
						{t("account.deleteAccount.confirmDelete")}
					</Button>
					<Button variant="outline" onClick={handleClose} fullWidth>
						{t("common.cancel")}
					</Button>
				</Stack>
			</Stack>
		</Modal>
	);
}; 